import React from "react";
import styles from "./cp-data-table-footer.styles.css";

type CpDataTableFooterProps = {
  className?: string;
  children?: React.ReactNode;
};

export function CpDataTableFooter({
  className,
  children,
}: CpDataTableFooterProps) {
  return (
    <div className={`${styles.footer} ${className || ""}`}>{children}</div>
  );
}
